// Pages layouts
import Blank from './blank';
import TwoColumns from './two-columns';
import TwoColumnsNoContainer from './two-columns-no-container';
import FullWidth from './full-width';
import FullWidthNoContainer from './full-width-no-container';
import OneColumn from './one-column';
import WebviewCounter from './webview-counter';
import Webview from './webview';

export default {
    blank: Blank,
    'two-columns': TwoColumns,
    'two-columns-no-container': TwoColumnsNoContainer,
    'full-width': FullWidth,
    'full-width-no-container': FullWidthNoContainer,
    'one-column': OneColumn,
    'webview-counter': WebviewCounter,
    webview: Webview,
};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/layouts/index.js